import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=37f530d4&scoped=true&"
import script from "./Permissions.vue?vue&type=script&lang=ts&"
export * from "./Permissions.vue?vue&type=script&lang=ts&"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=37f530d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f530d4",
  null
  
)

export default component.exports